import DOMPurify from 'dompurify';

/**
 * Sanitize CMS/blog HTML before it reaches dangerouslySetInnerHTML.
 * Content is admin-authored (endpoints are admin-gated since the B2 audit),
 * so this is defense-in-depth against a compromised admin account or a
 * stored-XSS payload smuggled through the CMS editor.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    // Keep formatting, media and links; drop scripts, event handlers, forms.
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select'],
    ADD_ATTR: ['dir', 'lang'],
  });
}

/**
 * Guard admin-authored CSS that is injected into a <style> tag: DOMPurify
 * doesn't parse CSS, so just prevent breaking out of the style element
 * (the only way CSS text can become HTML/script context).
 */
export function sanitizeCss(css: string): string {
  return css.replace(/<\/style/gi, '');
}
